import React, { useState, useEffect, useMemo } from 'react'

import { Alert } from '@vtex/shoreline'

import { formatAxiosError } from '~/helpers/errors'

/**
 * Gerencia o componente de alerta. Recebe um objeto com o erro.
 *
 * @example
 *
 *  const [AlertOnError] = useAlert(error);
 *
 *  <AlertOnError />
 *
 * @returns Um componente de alerta com a mensagem de erro enviada
 *
 * @param {string} error Mensagem de erro
 *
 */

const useAlert = (errorRaw = null) => {
  const [alert, setAlert] = useState(true)

  const error = errorRaw ? formatAxiosError(errorRaw) : null

  // Gerenciando os alertas
  const handleAlert = useMemo(
    () => ({
      show: () => {
        if (error && !alert) {
          setAlert(true)
        }
      },
      close: () => {
        setAlert(false)
      }
    }),
    [error, alert]
  )

  useEffect(() => {
    handleAlert.show()

    if (!error && alert) {
      handleAlert.close()
    }
  }, [error, alert, handleAlert])

  const component = () => {
    return (
      alert &&
      !!error && (
        <Alert
          variant="critical"
          onDismiss={handleAlert.close}
          className="mt-3 align-items-center"
        >
          {error || ''}
        </Alert>
      )
    )
  }

  return [component]
}

export { useAlert }
